<template>
    <!-- 单选框组二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <index-form-item :labelText="labelName"
                   :labelWidth="labelWidth"
                   :labelPosition="labelPosition"
                   :textAlign="labelTextPosition"
                   :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-radio-group :disabled="isDisabled"
                      :style="{
                        marginTop: displayType == 'block' ? '-5px' : '0'
                      }">
        <el-radio v-for="(item,index) in options" :key="index"
                  :style="{ display: displayType,
                            lineHeight: displayType == 'block' ? '28px' : '20px',
                            }"
                  :label="item.label">
                  {{item.value}}
        </el-radio>
      </el-radio-group>
    </div>
  </index-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 表单项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  mixins: [ mixFormItemTemplateChild ]
}

</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemRadio.vue